<mat-card>
  <mat-card-header>
    <mat-card-title>{{'digital-certificate-default.screen_name' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
<!--        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">-->
<!--          <span>{{'digital-certificate-default.ttl_search' | translate}}</span>-->
<!--          <button class="pull-right" (click)="openAddCertificateDefaultDialog()" mat-stroked-button color="primary">-->
<!--            <mat-icon class="mr-0">add_circle</mat-icon>{{'digital-certificate-default.buttons.add' | translate}}-->
<!--          </button>-->
<!--        </mat-panel-title>-->
        <!-- Start table -->
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource"  matSort (matSortChange)="sortData($event)">

            <!-- Số thứ tự -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{element.STT}}
              </mat-cell>
            </ng-container>

            <!-- Nhà cung cấp -->
            <ng-container matColumnDef="cloudCaProviderName">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'digital_certificate_management.lbl_provider_cloudca' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-left mat-cell-non-boder-right-bottom"  matTooltip="{{element.cloudCaProviderName}}">
                  {{element.cloudCaProviderName}}
              </mat-cell>
            </ng-container>

            <!-- Phương thức ký -->
            <ng-container matColumnDef="typeCertificate">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.digital_certificate_type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center mat-cell-non-boder-right-bottom">
                <div *ngIf="element.typeCertificate == 0" class="w-100 text-left" >
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 1" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_usb_token' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 2" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_card_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 3" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_OTP' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == 4" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_HSM' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == enumSignMethod.CLOUD_CA" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == enumSignMethod.EASY_CA" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_EASY_CA' | translate}}
                </div>
                <div *ngIf="element.typeCertificate == enumSignMethod.VNEID" class="w-100 text-left">
                  {{'enterprise-certificate_management.cbx_certificate_type.cbx_vneid' | translate}}
                </div>
              </mat-cell>
            </ng-container>

            <!-- Chủ thể -->
            <ng-container matColumnDef="issuedTo">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.subject_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom word-break-line" matTooltip="{{element.issuedTo}}">
                {{element.issuedTo}}
              </mat-cell>
            </ng-container>

            <!-- Serial number -->
            <ng-container matColumnDef="serialNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom word-break-line" matTooltip="{{element.serialNumber}}">
                {{element.serialNumber}}
              </mat-cell>
            </ng-container>

            <!-- Mã số thuế -->
            <ng-container matColumnDef="taxCode">
              <mat-header-cell *matHeaderCellDef  mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.tax_code_cmtnd' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-right word-break-line" matTooltip="{{element.taxCode}}">
                {{element.taxCode}}
              </mat-cell>
            </ng-container>

            <!-- Số điện thoại -->
            <ng-container matColumnDef="phoneNumber">
              <mat-header-cell *matHeaderCellDef  mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.phone_number' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.phoneNumber}}
              </mat-cell>
            </ng-container>

            <!-- Ngày hiệu lực -->
            <ng-container matColumnDef="activeDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.activeDate | dateformat}}
              </mat-cell>
            </ng-container>

            <!-- Ngày hết hạn -->
            <ng-container matColumnDef="expireDate">
              <mat-header-cell *matHeaderCellDef  mat-sort-header
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                {{element.expireDate | dateformat}}
              </mat-cell>
            </ng-container>

            <!-- Trạng thái -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%;"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom word-break-line">
                <div *ngIf="element.certificateStatus == 0" class="w-100 text-center" style="color: #09847b">
                  {{'enterprise-certificate_management.certificate_status.active' | translate}}
                </div>
                <div *ngIf="element.certificateStatus == 1" class="w-100 text-center" style="color: #da190b">
                  {{'enterprise-certificate_management.certificate_status.pending' | translate}}
                </div>
                <div *ngIf="element.certificateStatus == 2" class="w-100 text-center">
                  {{'enterprise-certificate_management.certificate_status.expired' | translate}}
                </div>
              </mat-cell>
            </ng-container>

            <!-- Tự động đồng bộ -->
            <ng-container matColumnDef="isSync">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'digital_certificate_management.auto_sync' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%; width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div *ngIf="element.isSync == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                  {{ 'button.yes_sign_method_default' | translate }}
                </div>
                <div *ngIf="element.isSync != true && element.typeCertificate == 10" [matTooltip]="'button.no' | translate" style="color: #da190b">
                  {{ 'button.no' | translate }}
                </div>
              </mat-cell>
            </ng-container>
            
            <!-- Lưu phiên ký -->
            <ng-container matColumnDef="hasTransSaved">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;" style="width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.save_session_sign' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%;" style="width: 10%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div *ngIf="element.hasTransSaved == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                  {{ 'button.yes_sign_method_default' | translate }}
                </div>
                <div *ngIf="element.hasTransSaved == false" [matTooltip]="'button.no' | translate" style="color: #da190b">
                  {{ 'button.no' | translate }}
                </div>
              </mat-cell>
            </ng-container>
            
            <!-- Phương thức ký mặc định Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol mat-cell-non-boder-bottom">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"
                style="max-width: 8%;">
                {{'headertable.certificate_default' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"
                (click)="$event.stopPropagation()" style="max-width: 8%;">
<!--                <div class="w-100 text-center">-->
<!--                  <div *ngIf="element.defaultCertificate">-->
<!--                    x-->
<!--                  </div>-->
<!--                </div>-->
                <nz-switch [(ngModel)]="element.defaultCertificate" (click)="changDefaultStatus(element)" [nzControl]="true" [nzDisabled]="commonService.getIsLockedEnterprise()"></nz-switch>
              </mat-cell>
            </ng-container>
            <!-- Tác động Column -->
            <ng-container matColumnDef="detail" class="mat-column-symbol mat-cell-non-boder-bottom">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"
                               style="max-width: 8%;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"
                        (click)="$event.stopPropagation()" style="max-width: 8%;">

                <!--  view detail  -->
                <button mat-icon-button
                        (click)="viewDigitalCertificateDetail(element.id, element.idDetail, element.typeCertificate)">
                  <mat-icon matTooltip="{{'enterprise-certificate_management.table_headers.view_detail' | translate}}">
                    visibility
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
            </mat-row>
          </mat-table>
        </div>
        <!-- End table -->
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
